import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    LocationType,
} from 'app/enums/label.enums'

import {
    Company,
} from 'app/Apps/ContactManagement/Companies/Companies.types'
import {
    SizeLink, TypeLink,
} from 'app/shared-components/SkyNetLink'

import {
    LoggerResponse,
} from '../Loggers.types'
import {
    availableLoggerStatuses,
} from '../Logger/Logger.utils'
import {
    loggerGatewayCardFields, loggerTransmissionFields,
} from '../Logger/Logger.fields'

export type LoggerUpdate = {
    batteryVoltage: string | number,
    containerSerialNumber: string,
    hardwareVersion?: string,
    softwareVersion?: string,
    lastCalibratedOn?: string,
    'gateway.locationRemark': string,
    'gateway.location.id': string,
    'gateway.areaName': string,
    'gateway.gatewayImeiMac': string,
}

type LoggerUpdateFields = LoggerUpdate & LoggerResponse & {
    'gateway.gatewayImeiMac': string,
}

const getLoggerUpdateFields = ({
    rentingCompany,
    containerSerialNumber,
    containerLink,
}: {
    rentingCompany: Company
    containerSerialNumber: string | null
    containerLink: string | null
}): DTOCardFormField<keyof LoggerUpdateFields>[] => {
    return [
        {
            id: 'loggers',
            title: 'Logger',
            className: 'loggers',
            fields: [
                {
                    id: 'column1',
                    fields: [
                        {
                            name: 'loggerNumber',
                            componentName: 'InputSingleline',
                            disabled: true,
                            labelKey: 'LOGGER',
                        },
                        {
                            name: 'loggerQrCode',
                            componentName: 'InputSingleline',
                            required: true,
                            labelKey: 'LOGGER_QR_CODE',
                        },
                        {
                            name: 'containerSerialNumber',
                            componentName: 'SkyNetLink',
                            link: containerLink,
                            text: containerSerialNumber,
                            type: TypeLink.INTERNAL_WITH_ICON,
                            size: SizeLink.S,
                            labelKey: 'CONTAINER_SERIAL_NUMBER',
                        },
                        {
                            name: 'loggerStatus',
                            componentName: 'EnumSelector',
                            allowedValues: availableLoggerStatuses,
                            useDropdown: true,
                            required: true,
                            labelKey: 'LOGGER_STATUS',
                        },
                        {
                            name: 'loggerType',
                            componentName: 'LoggerTypeSelector',
                            disabled: true,
                            labelKey: 'LOGGER_TYPE',
                        },
                    ],
                },
                {
                    id: 'column2',
                    fields: [
                        {
                            name: 'isTestingLogger',
                            componentName: 'Checkbox',
                            labelKey: 'IS_TESTING_LOGGER',
                        },
                        {
                            name: 'hardwareVersion',
                            componentName: 'InputSingleline',
                            labelKey: 'HARDWARE_VERSION',
                        },
                        {
                            name: 'softwareVersion',
                            componentName: 'InputSingleline',
                            labelKey: 'SOFTWARE_VERSION',
                        },
                        {
                            name: 'location',
                            componentName: 'LocationObjectSelector',
                            filterLocationType: LocationType.ADDRESS,
                            labelKey: 'LOCATION',
                        },
                        {
                            name: 'rentingCompany',
                            componentName: 'CompanyObjectSelector',
                            disabled: !!rentingCompany,
                            labelKey: 'RENTING_COMPANY',
                        },
                        {
                            name: 'batteryVoltage',
                            componentName: 'IntegerInput',
                            disabled: true,
                            labelKey: 'BATTERY_VOLTAGE_MV',
                        },
                        {
                            name: 'destinationLocation',
                            componentName: 'LocationObjectSelector',
                            labelKey: 'DESTINATION_LOCATION',
                        },
                    ],
                },
                {
                    id: 'column3',
                    fields: loggerTransmissionFields,
                },
            ],
        },
        loggerGatewayCardFields,
    ]
}

export default getLoggerUpdateFields
